/* GemIQ Software page: scroll motion and widgets for the gstudio-* sections.
   Adapted from the original static page script. Every part checks that its section is on the page,
   pinned scenes sit under whatever part of the theme header stays stuck (--gs-navh), and the whole
   thing restarts when the theme editor reloads, adds, removes or reorders a section. */
(function(){
  if (window.__gstudio) return; window.__gstudio = true;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* height of the theme header pieces that stay stuck at the top while the page scrolls (the BF strip, a sticky header) */
  function navH(){
    var h = 0;
    [].forEach.call(document.querySelectorAll('.shopify-section-group-header-group'), function(s){
      var cs = getComputedStyle(s);
      if ((cs.position === 'sticky' || cs.position === 'fixed') && cs.display !== 'none' && s.offsetHeight) h = Math.max(h, (parseFloat(cs.top) || 0) + s.offsetHeight);
    });
    return h;
  }
  function setNav(){ var h = navH(); document.documentElement.style.setProperty('--gs-navh', h + 'px'); return h; }

  function init(){
    var ac = new AbortController(), timers = [], alive = true;
    function on(t, ev, fn, o){ if (t) t.addEventListener(ev, fn, Object.assign({signal: ac.signal}, o || {})); }
    function every(fn, ms){ timers.push(setInterval(fn, ms)); }
    function later(fn, ms){ timers.push(setTimeout(fn, ms)); }
    var byId = function(id){ return document.getElementById(id); };
    var all = function(sel, root){ return [].slice.call((root || document).querySelectorAll(sel)); };
    var navNow = setNav();

    /* reveals */
    var rv = all('.gstudio .reveal');
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, {rootMargin:'0px 0px -8% 0px'});
      rv.forEach(function(el){ io.observe(el); });
      ac.signal.addEventListener('abort', function(){ io.disconnect(); });
    } else rv.forEach(function(el){ el.classList.add('is-in'); });

    /* loops: duplicate tracks for a seamless marquee (once per track, even across editor restarts) */
    function loop(id){ var t = byId(id); if (!t || reduce || t.hasAttribute('data-gs-looped')) return; t.setAttribute('data-gs-looped', ''); t.insertAdjacentHTML('beforeend', t.innerHTML.replace(/\sdata-shopify-editor-block="[^"]*"/g, '').replace(/<(li|figure|img)\b/g, '<$1 aria-hidden="true"')); }
    loop('track'); loop('logos-track'); loop('track2');

    /* the AI description types itself out once it scrolls into view */
    var typed = byId('typed');
    if (typed && !reduce && !typed.hasAttribute('data-gs-typed') && 'IntersectionObserver' in window && typed.closest('.rcard')) {
      var typeOnce = function(){
        typed.setAttribute('data-gs-typed', '');
        var caret = typed.querySelector('.caret'), full = typed.textContent, node = document.createTextNode(''), i = 0;
        typed.textContent = ''; typed.appendChild(node); if (caret) typed.appendChild(caret);
        (function step(){ i += 2; node.data = full.slice(0, i); if (i < full.length) later(step, 16); else if (caret) caret.style.display = 'none'; })();
      };
      var tio = new IntersectionObserver(function(es){ if (es.some(function(e){ return e.isIntersecting; })) { tio.disconnect(); typeOnce(); } }, {threshold:.5});
      tio.observe(typed.closest('.rcard'));
      ac.signal.addEventListener('abort', function(){ tio.disconnect(); });
    }

    /* share: the accordion steps through its items as the pinned section scrolls; a click jumps to that step */
    var shareSec = byId('share'), shareTrack = byId('share-track'), sharePin = byId('share-pin');
    var shareStep = function(){};
    if (shareSec && shareTrack && sharePin) {
      var items = all('.acc-item', shareSec), shareImgs = all('.share-media img', shareSec);
      var scrollyMq = matchMedia('(min-width: 901px) and (min-height: 760px)'), accIdx = 0, accTick = false;
      shareSec.style.setProperty('--steps', Math.max(1, items.length));
      var openAcc = function(i){
        accIdx = i;
        shareImgs.forEach(function(im, j){ im.classList.toggle('is-on', j === i); });
        items.forEach(function(o, j){ var on = j === i; o.classList.toggle('is-open', on); var b = o.querySelector('.acc-btn'); if (b) b.setAttribute('aria-expanded', on); });
      };
      var shareRange = function(){ return shareTrack.offsetHeight - sharePin.offsetHeight; };
      shareStep = function(){
        accTick = false;
        if (!items.length || !shareSec.classList.contains('is-scrolly')) return;
        var top = parseFloat(getComputedStyle(sharePin).top) || 0, range = shareRange();
        var p = Math.min(1, Math.max(0, (top - shareTrack.getBoundingClientRect().top) / range));
        var i = Math.min(items.length - 1, Math.floor(p * items.length));
        if (i !== accIdx) openAcc(i);
        items[i].style.setProperty('--fill', Math.min(1, Math.max(.04, p * items.length - i)).toFixed(3));
      };
      var shareOpenAll = function(){ if (shareSec.classList.contains('is-scrolly')) return; all('.acc-btn', shareSec).forEach(function(b){ b.setAttribute('aria-expanded', 'true'); b.tabIndex = -1; }); };
      var setScrolly = function(){
        var was = shareSec.classList.contains('is-scrolly'), now = scrollyMq.matches;
        shareSec.classList.toggle('is-scrolly', now);
        if (now && !was) all('.acc-btn', shareSec).forEach(function(b){ b.removeAttribute('tabindex'); });
        items.forEach(function(o){ o.style.removeProperty('--fill'); });
        if (now) openAcc(accIdx); else shareOpenAll();
        shareStep();
      };
      items.forEach(function(it, i){
        on(it.querySelector('.acc-btn'), 'click', function(){
          if (!shareSec.classList.contains('is-scrolly')) { openAcc(i); return; }
          var top = parseFloat(getComputedStyle(sharePin).top) || 0;
          var y = shareTrack.getBoundingClientRect().top + scrollY - top + shareRange() * (i + .06) / items.length;
          openAcc(i); scrollTo({top: Math.round(y), behavior: reduce ? 'auto' : 'smooth'});
        });
      });
      on(window, 'scroll', function(){ if (!accTick) { accTick = true; requestAnimationFrame(shareStep); } }, {passive:true});
      on(window, 'resize', setScrolly);
      setScrolly();
    }

    /* FAQ: one open at a time */
    var faqs = all('.gstudio .faq-item');
    faqs.forEach(function(d){ on(d, 'toggle', function(){ if (d.open) faqs.forEach(function(o){ if (o !== d && o.open) o.open = false; }); }); });

    /* testimonials: the section renders them as JSON in #t-data */
    var tData = byId('t-data'), T = [];
    try { T = tData ? JSON.parse(tData.textContent) : []; } catch (e) { T = []; }
    var tImg = byId('t-img'), dots = byId('t-dots'), faces = byId('faces');
    if (T.length && tImg && dots && faces) {
      var ti = 0;
      dots.innerHTML = ''; faces.innerHTML = '';
      var show = function(i){
        ti = (i + T.length) % T.length; var t = T[ti];
        tImg.src = t.img; tImg.alt = t.name + ', ' + t.biz;
        byId('t-name').textContent = t.name;
        byId('t-biz').textContent = t.biz;
        byId('t-quote').textContent = '“' + t.quote + '”';
        [].forEach.call(dots.children, function(d, j){ d.setAttribute('aria-current', j === ti); });
        [].forEach.call(faces.children, function(d, j){ d.setAttribute('aria-current', j === ti); });
      };
      T.forEach(function(t, i){
        var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Show ' + t.name); on(d, 'click', function(){ show(i); }); dots.appendChild(d);
        var f = document.createElement('button'); f.type = 'button';
        var fi = document.createElement('img'); fi.src = t.img; fi.alt = ''; var fs = document.createElement('span'); fs.textContent = t.name;
        f.appendChild(fi); f.appendChild(fs); f.setAttribute('aria-label', t.name + ', ' + t.biz); on(f, 'click', function(){ show(i); }); faces.appendChild(f);
      });
      on(byId('t-prev'), 'click', function(){ show(ti - 1); });
      on(byId('t-next'), 'click', function(){ show(ti + 1); });
      show(0);
    }

    /* book your demo pop-up: validates, then posts the theme's contact form (the store gets the request by email) */
    var dlg = byId('demo'), card = dlg && dlg.querySelector('.demo-card'), form = byId('d-form');
    var openDemo = null;
    if (dlg && card && form) {
      form.noValidate = true;
      var btn = form.querySelector('button[type=submit]'), lbl = btn && btn.querySelector('.lbl');
      var emailOk = function(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); };
      var $ = function(id){ return byId('d-' + id); };
      var tzName = ''; try { tzName = Intl.DateTimeFormat().resolvedOptions().timeZone.replace(/_/g, ' '); } catch (e) {}
      if (tzName) all('[data-tz]', card).forEach(function(t){ t.textContent = '(' + tzName + ')'; });
      var mark = function(fld, bad){ if (!fld) return; fld.classList.toggle('is-bad', bad); var i = fld.querySelector('input'); if (i) i.setAttribute('aria-invalid', bad ? 'true' : 'false'); };
      var clearErr = function(){ all('.is-bad', form).forEach(function(x){ x.classList.remove('is-bad'); }); };
      var validate = function(){
        var first = null, bad;
        [['first', function(v){ return v.trim(); }], ['last', function(v){ return v.trim(); }], ['biz', function(v){ return v.trim(); }], ['email', emailOk]].forEach(function(r){
          var inp = $(r[0]); if (!inp) return; bad = !r[1](inp.value); mark(inp.closest('.fld'), bad); if (bad && !first) first = inp;
        });
        var g = form.querySelector('[data-g=sell]');
        if (g) { bad = !g.querySelector('input:checked'); g.classList.toggle('is-bad', bad); if (bad && !first) first = g.querySelector('input'); }
        return first;
      };
      on(form, 'input', function(e){
        var f = e.target.closest('.fld.is-bad, .grp.is-bad'); if (!f) return;
        if (f.matches('[data-g=sell]')) f.classList.toggle('is-bad', !f.querySelector('input:checked'));
        else if (e.target.type === 'email') mark(f, !emailOk(e.target.value)); else mark(f, !e.target.value.trim());
      });
      on(form, 'change', function(e){ var f = e.target.closest('[data-g=sell].is-bad'); if (f) f.classList.toggle('is-bad', !f.querySelector('input:checked')); });
      on(form, 'submit', function(e){
        var bad = validate(); if (bad) { e.preventDefault(); bad.focus(); return; }
        var d = new FormData(form), joined = {};
        all('[data-join]', form).forEach(function(h){ var k = h.getAttribute('data-join'); h.value = joined[k] = d.getAll(k).join(', '); });
        var time = form.querySelector('.seg input:checked');
        var biz = $('biz'), first = $('first'), email = $('email');
        try {
          sessionStorage.setItem('gstudio-demo', JSON.stringify({
            name: first ? first.value : '', email: email ? email.value : '',
            rows: [['Business', biz ? biz.value : ''], ['Sells', joined.sell || ''], ['Sells on', joined.where || 'Not specified'], ['Best time', time ? time.value : '']]
          }));
        } catch (err) {}
        if (btn) { btn.classList.add('is-loading'); if (lbl) lbl.textContent = btn.getAttribute('data-loading') || 'Booking your demo'; later(function(){ btn.disabled = true; }, 0); }
      });
      var lastFocus = null;
      openDemo = function(){
        if (dlg.open) return;
        lastFocus = document.activeElement;
        if (typeof dlg.showModal !== 'function') return false;
        dlg.showModal(); document.body.classList.add('has-modal');
        later(function(){ if (!card.classList.contains('is-done') && $('first')) $('first').focus(); }, 60);
      };
      var closeDemo = function(){ if (dlg.open) dlg.close(); };
      on(dlg, 'close', function(){
        document.body.classList.remove('has-modal');
        if (card.classList.contains('is-done')) { card.classList.remove('is-done'); form.reset(); clearErr(); }
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      });
      on(byId('demo-close'), 'click', closeDemo);
      on(dlg, 'click', function(e){
        if (e.target === dlg) { closeDemo(); return; }
        var c = e.target.closest('[data-close]'); if (c) { closeDemo(); if (!/^#/.test(c.getAttribute('href') || '') || c.getAttribute('href') === '#') e.preventDefault(); }
      });
      // after the contact form posts, the page reloads with the confirmation (or the error) to show
      if (form.querySelector('[data-demo-posted]')) {
        var sent = {}; try { sent = JSON.parse(sessionStorage.getItem('gstudio-demo') || '{}'); sessionStorage.removeItem('gstudio-demo'); } catch (err) {}
        var nm = card.querySelector('[data-f=name]'), em = card.querySelector('[data-f=email]'), recap = card.querySelector('[data-f=recap]');
        if (nm && sent.name) nm.textContent = sent.name;
        if (em && sent.email) em.textContent = sent.email;
        if (recap && sent.rows) {
          recap.innerHTML = '';
          sent.rows.forEach(function(r){ if (!r[1]) return; var li = document.createElement('li'), s = document.createElement('span'), b = document.createElement('b'); s.textContent = r[0]; b.textContent = r[1]; li.appendChild(s); li.appendChild(b); recap.appendChild(li); });
        }
        card.classList.add('is-done'); openDemo(); var done = card.querySelector('.demo-done'); if (done) done.focus();
      } else if (form.querySelector('.demo-error') || location.hash === '#book') openDemo();
    }
    // "Book a demo" links open the pop-up; without it they simply follow their link
    on(document, 'click', function(e){
      var t = e.target.closest('[data-demo]'); if (!t || !openDemo) return;
      if (openDemo() !== false) e.preventDefault();
    });

    /* ---- v2 motion: one smoothed scroll value drives every scroll-linked moment on the page ---- */
    var clamp = function(v, a, b){ return v < a ? a : v > b ? b : v; };
    var ease = function(t){ return 1 - Math.pow(1 - t, 3); };
    var easeIO = function(t){ return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
    var lerpF = function(a, b, t){ return a + (b - a) * t; };
    var absTop = function(el){ return el.getBoundingClientRect().top + scrollY; };
    var writes = new Map();
    function put(el, prop, val){ var m = writes.get(el); if (!m) { m = {}; writes.set(el, m); } if (m[prop] === val) return; m[prop] = val; if (prop.charAt(0) === '-') el.style.setProperty(prop, val); else el.style[prop] = val; }

    /* ---- hero: the wall zooms into one ring, which pulls back into the GemIQ editor ---- */
    var cw = document.querySelector('.gstudio .cw'), cwPin = byId('cw-pin'), cwWall = byId('cw-wall');
    var cwCopy = byId('cw-copy'), cwVeil = byId('cw-veil'), cwCue = byId('cw-cue');
    var cwPort = byId('cw-port'), cwScene = byId('cw-scene'), cwRing = byId('cw-ring'), cwAfter = document.querySelector('.gstudio .cw-after');
    var hasHero = !!(cw && cwPin && cwWall && cwCopy && cwVeil && cwCue && cwPort && cwScene && cwRing);
    var cwCols = hasHero ? all('.cw-col', cwWall) : [], cwFocus = hasHero ? cwWall.querySelector('.is-focus') : null;
    if (!cwFocus) hasHero = false;
    var CARD = {x: 879.75, y: 254.76, w: 323, h: 305.1};
    var cwMotion = false, H = {};
    var colPar = [-170, 110, -70, 0, 130, -100, 190], colLift = [-40, -160, -10, 0, -120, -30, -190];
    var cwDecoded = false;
    function heroLayout(){
      if (!hasHero) return;
      if (!cwDecoded) { cwDecoded = true; all('img', cwWall).forEach(function(i){ if (i.decode) i.decode().catch(function(){}); }); }
      cwMotion = !reduce && innerHeight >= 560;
      cw.classList.toggle('is-static', !cwMotion);
      if (!cwMotion) { if (cwPort.parentNode !== cw) cw.appendChild(cwPort); } else if (cwPort.parentNode !== cwPin) cwPin.appendChild(cwPort);
      cwCols.forEach(function(c){ c.style.transform = ''; });
      put(cwWall, 'transform', 'none');
      var vw = cwPin.clientWidth, ph = cwPin.clientHeight, mobile = vw < 700;
      // park the focus tile low in the centre column, under the copy
      var col = cwFocus.parentNode; col.style.marginTop = '0px';
      var fr = cwFocus.getBoundingClientRect(), wr = cwWall.getBoundingClientRect();
      var want = ph * (mobile ? .8 : .79) - fr.height / 2;
      col.style.marginTop = (want - (fr.top - wr.top)) + 'px';
      cwCols.forEach(function(c, i){ if (c !== col) c.style.marginTop = (want - (fr.top - wr.top)) * .35 + (colLift[i % 7]) + 'px'; });
      fr = cwFocus.getBoundingClientRect(); wr = cwWall.getBoundingClientRect();
      var pr = cwPin.getBoundingClientRect();
      H.vw = vw; H.ph = ph; H.cx = vw / 2; H.cy = ph / 2;
      H.fx = fr.left - wr.left + fr.width / 2; H.fy = fr.top - wr.top + fr.height / 2;   // focus centre in wall space
      H.wx = wr.left - pr.left; H.wy = wr.top - pr.top;                                   // wall origin in pin space
      var target = Math.min(vw * (mobile ? .74 : .46), ph * .62 * CARD.w / 305, 640);
      H.S = target / fr.width; H.Z = target / CARD.w;
      // the editor card's corners, scaled to the tile, so tile and card match during the crossfade
      cwFocus.style.borderRadius = (14.324 * fr.width / CARD.w).toFixed(2) + 'px';
      var visH = 713 * .86;
      H.F = mobile ? vw / 1000 : Math.min(1, vw / 1400, (ph - 80) / visH);
      var top0 = Math.max(8, (ph - visH * H.F) / 2);
      H.nx = H.cx + (CARD.x - 960) * H.F; H.ny = top0 + CARD.y * H.F;
      // on phones the laptop is short, so the pinned frame ends in a tall empty band: pull the heading block up into it
      var pull = cwMotion && mobile ? Math.max(0, Math.min(220, ph - (top0 + visH * H.F) - 48)) : 0;
      if (cwAfter) cwAfter.style.marginTop = pull ? (-pull).toFixed(0) + 'px' : '';
      H.top = absTop(cw) - navNow; H.len = cw.offsetHeight - ph;
      if (!cwMotion) {
        var F = mobile ? vw / 1000 : Math.min(1, vw / 1400), sh = Math.round(713 * .86 * F + 60);
        cw.style.setProperty('--sh', sh + 'px');
        put(cwScene, 'transform', 'translate3d(' + ((vw - 1920 * F) / 2).toFixed(1) + 'px,10px,0) scale(' + F.toFixed(4) + ')');
        put(cwScene, 'opacity', '1');
      }
    }
    function heroFrame(sy){
      if (!hasHero || !cwMotion) return;
      var p = clamp((sy - H.top) / H.len, 0, 1);
      var a = ease(clamp(p / .2, 0, 1));
      var z = easeIO(clamp((p - .06) / .46, 0, 1));
      var x = clamp((p - .5) / .07, 0, 1);
      var b = easeIO(clamp((p - .58) / .36, 0, 1));
      put(cwCopy, 'opacity', (1 - a).toFixed(3));
      put(cwCopy, 'transform', 'translate(-50%,calc(-50% - ' + (a * 70).toFixed(1) + 'px)) scale(' + (1 - a * .05).toFixed(4) + ')');
      put(cwCopy, 'filter', a > .001 ? 'blur(' + (a * 9).toFixed(2) + 'px)' : 'none');
      put(cwCopy, 'pointerEvents', a > .4 ? 'none' : 'auto');
      put(cwVeil, 'opacity', (1 - a).toFixed(3));
      // white until the ring starts to zoom, then the ground settles to the page grey
      var g = ease(clamp(z / .3, 0, 1));
      put(cw, '--cwbg', 'rgb(' + Math.round(255 - 10 * g) + ',' + Math.round(255 - 10 * g) + ',' + Math.round(255 - 8 * g) + ')');
      put(cwCue, 'opacity', Math.max(0, 1 - a * 3).toFixed(3));
      var s = Math.exp(lerpF(0, Math.log(H.S), z));
      var ox = (H.cx - (H.wx + H.fx)) * z, oy = (H.cy - (H.wy + H.fy)) * z;
      put(cwWall, 'transformOrigin', H.fx.toFixed(1) + 'px ' + H.fy.toFixed(1) + 'px');
      put(cwWall, 'transform', 'translate3d(' + ox.toFixed(1) + 'px,' + oy.toFixed(1) + 'px,0) scale(' + s.toFixed(4) + ')');
      var pc = Math.min(1, p / .55);
      cwCols.forEach(function(col, i){ put(col, 'transform', 'translate3d(0,' + (colPar[i % 7] * pc).toFixed(1) + 'px,0)'); });
      put(cwWall, '--o', (1 - z * .9).toFixed(3));
      put(cwFocus, 'opacity', x > 0 ? '0' : '1');
      put(cwWall, 'visibility', x >= 1 ? 'hidden' : 'visible');
      if (x <= 0) { put(cwScene, 'opacity', '0'); put(cwRing, 'opacity', '0'); }
      else {
        var zs = Math.exp(lerpF(Math.log(H.Z), Math.log(H.F), b));
        var Cx = lerpF(H.cx, H.nx, b), Cy = lerpF(H.cy, H.ny, b);
        put(cwScene, 'opacity', x.toFixed(3));
        put(cwScene, 'transform', 'translate3d(' + (Cx - CARD.x * zs).toFixed(1) + 'px,' + (Cy - CARD.y * zs).toFixed(1) + 'px,0) scale(' + zs.toFixed(4) + ')');
        var rw = CARD.w * zs, rh = CARD.h * zs;
        put(cwRing, 'opacity', '1');
        put(cwRing, 'width', rw.toFixed(2) + 'px'); put(cwRing, 'height', rh.toFixed(2) + 'px');
        put(cwRing, 'borderRadius', (14.324 * zs).toFixed(2) + 'px');
        put(cwRing, 'transform', 'translate3d(' + (Cx - rw / 2).toFixed(2) + 'px,' + (Cy - rh / 2).toFixed(2) + 'px,0)');
      }
    }

    /* ---- the ending heading: the jewelry word rotates ---- */
    var rot = byId('cw-rot'), rotW = rot ? [].slice.call(rot.children) : [], rotI = 0;
    if (rot && rotW.length) {
      rotW.forEach(function(w, i){ w.classList.remove('is-out'); w.classList.toggle('is-on', i === 0); });
      var rotSize = function(){ rot.style.width = rotW[rotI].offsetWidth + 'px'; };
      rotSize(); on(window, 'resize', rotSize); if (document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ if (alive) rotSize(); });
      if (!reduce && rotW.length > 1) every(function(){
        var out = rotW[rotI]; rotI = (rotI + 1) % rotW.length; var inn = rotW[rotI];
        out.classList.remove('is-on'); out.classList.add('is-out');
        inn.classList.remove('is-out'); inn.classList.add('is-on');
        rot.style.width = inn.offsetWidth + 'px';
        later(function(){ out.classList.remove('is-out'); }, 650);
      }, 1800);
    }

    /* ---- logos: the marquee drifts, and runs with the scroll ---- */
    var logoTrack = byId('logos-track'), logoX = 0, logoDir = 1, lastY = scrollY;
    function logoFrame(dt){
      if (reduce || !logoTrack) return;
      var v = scrollY - lastY; lastY = scrollY; if (v) logoDir = v > 0 ? 1 : -1;
      var half = logoTrack.scrollWidth / 2 + 40;
      logoX += (0.5 + Math.min(Math.abs(v), 60) * 0.55) * logoDir * dt;
      logoX = ((logoX % half) + half) % half;
      put(logoTrack, 'transform', 'translate3d(' + (-logoX).toFixed(1) + 'px,0,0)');
    }

    /* ---- feed: two rows slide against each other; the counter counts in ---- */
    var feedSec = document.querySelector('.gstudio .feed'), tr1 = byId('track'), tr2 = byId('track2');
    var cnt = byId('count'), cntStarted = false, F2 = {};
    var cntN = cnt ? parseInt(cnt.getAttribute('data-to'), 10) : NaN, cntFrom = cnt ? parseInt(cnt.getAttribute('data-from'), 10) : NaN;
    if (isNaN(cntN)) cnt = null; if (isNaN(cntFrom)) cntFrom = cntN;
    function feedLayout(){ if (!feedSec) return; F2.top = absTop(feedSec); F2.h = feedSec.offsetHeight; F2.h1 = tr1 ? tr1.scrollWidth / 2 : 0; F2.h2 = tr2 ? tr2.scrollWidth / 2 : 0; }
    function feedFrame(sy){
      if (!feedSec) return;
      var vh = innerHeight, p = clamp((sy + vh - F2.top) / (F2.h + vh), 0, 1);
      var swing = reduce ? 0 : 1;
      if (tr1) put(tr1, 'transform', 'translate3d(' + (-F2.h1 * .22 + (.5 - p) * 520 * swing).toFixed(1) + 'px,0,0)');
      if (tr2) put(tr2, 'transform', 'translate3d(' + (-F2.h2 * .5 + (p - .5) * 520 * swing).toFixed(1) + 'px,0,0)');
      if (cnt && !cntStarted && p > .18) {
        cntStarted = true;
        if (reduce) return;
        var t0 = performance.now(), from = cntFrom;
        (function run(t){ if (!alive) return; var k = ease(Math.min(1, (t - t0) / 1600)); cnt.textContent = Math.round(from + (cntN - from) * k).toLocaleString('en-US'); if (k < 1) requestAnimationFrame(run); else every(function(){ cntN += 1 + Math.floor(Math.random() * 3); cnt.textContent = cntN.toLocaleString('en-US'); }, 2400); })(t0);
      }
    }

    /* ---- workflow: each band is a shelf; arrows step a card at a time, hide when the shelf fits ---- */
    var wfCats = all('.gstudio .wf-cat');
    var wfShelves = wfCats.map(function(cat){
      var row = cat.querySelector('.wf-row'), btn = cat.querySelectorAll('.wf-arrow');
      if (!row) return function(){};
      function upd(){
        var max = row.scrollWidth - row.clientWidth;
        cat.classList.toggle('is-fit', max < 4);
        if (btn[0]) btn[0].disabled = row.scrollLeft < 4; if (btn[1]) btn[1].disabled = row.scrollLeft > max - 4;
      }
      function step(dir){
        var card = row.querySelector('.rcard'), gap = parseFloat(getComputedStyle(row).columnGap) || 20;
        if (card) row.scrollBy({left: dir * (card.offsetWidth + gap), behavior: reduce ? 'auto' : 'smooth'});
      }
      on(btn[0], 'click', function(){ step(-1); });
      on(btn[1], 'click', function(){ step(1); });
      on(row, 'scroll', upd, {passive: true});
      return upd;
    });
    function wfFit(){ wfShelves.forEach(function(f){ f(); }); }
    wfFit(); on(window, 'resize', wfFit); on(window, 'load', wfFit);

    /* ---- simple scroll-linked reveals ---- */
    function span(el, startAt, len){ return {el: el, top: 0, s: startAt, l: len}; }
    var kItems = all('.gstudio .c2').map(function(e){ return span(e, .86, .34); })
      .concat(all('.gstudio .pgrid li').map(function(e, i){ return span(e, .96 - (i % 4) * .03, .3); }))
      .concat(all('.gstudio .i2-row').map(function(e, i){ return span(e, .95 - (i % 2) * .03, .28); }))
      .concat(all('.gstudio .plans .plan-card').map(function(e, i){ return span(e, 1 - i * .06, .4); }))
      .concat([document.querySelector('.gstudio .tcar'), byId('fin')].filter(Boolean).map(function(e, i){ return span(e, 1, i ? .85 : .7); }))
      .concat(wfCats.map(function(e){ return span(e, .9, .55); }));
    var diffEl = byId('diff'), D = {};
    if (diffEl) { var dPts = all('.dcard.dark li', diffEl); dPts.forEach(function(li, i){ li.style.setProperty('--n', i); }); diffEl.style.setProperty('--pts', dPts.length); }
    function kLayout(){ kItems.forEach(function(it){ it.top = absTop(it.el); }); if (diffEl) { D.top = absTop(diffEl); D.h = diffEl.offsetHeight; } }
    function kFrame(sy){
      var vh = innerHeight;
      kItems.forEach(function(it){ put(it.el, '--k', (reduce ? 1 : ease(clamp((sy + vh * it.s - it.top) / (vh * it.l), 0, 1))).toFixed(3)); });
      if (diffEl) put(diffEl, '--d', (reduce ? 1 : ease(clamp((sy + vh * .75 - D.top) / (vh * .55), 0, 1))).toFixed(3));
    }

    /* ---- the loop ---- */
    var sy = scrollY, lastT = performance.now(), laidOut = false;
    function layoutAll(){ if (!alive) return; writes.clear(); navNow = setNav(); heroLayout(); feedLayout(); kLayout(); wfFit(); shareStep(); laidOut = true; sy = scrollY; frame(sy); }
    function frame(y){ heroFrame(y); feedFrame(y); kFrame(y); }
    function tick(t){
      if (!alive) return;
      var dt = Math.min(3, (t - lastT) / 16.67); lastT = t;
      var target = scrollY, k = reduce ? 1 : 1 - Math.pow(1 - .16, dt);
      sy += (target - sy) * k; if (Math.abs(target - sy) < .25) sy = target;
      if (laidOut) frame(sy);
      logoFrame(dt);
      requestAnimationFrame(tick);
    }
    var lt; on(window, 'resize', function(){ clearTimeout(lt); lt = setTimeout(layoutAll, 140); });
    on(window, 'load', layoutAll);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layoutAll);
    // late images and the theme header (its strip can appear or hide) shift positions: lay out again when sizes change
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function(){ clearTimeout(lt); lt = setTimeout(layoutAll, 140); });
      all('.gstudio').concat(all('.shopify-section-group-header-group')).forEach(function(el){ ro.observe(el); });
      ac.signal.addEventListener('abort', function(){ ro.disconnect(); });
    }
    layoutAll();
    requestAnimationFrame(tick);

    return function stop(){ alive = false; ac.abort(); timers.forEach(function(id){ clearInterval(id); clearTimeout(id); }); clearTimeout(lt); };
  }

  var stop = init();
  // theme editor: sections are re-rendered in place, so start over with the new markup
  var rt;
  function restart(){ clearTimeout(rt); rt = setTimeout(function(){ if (stop) stop(); stop = init(); }, 60); }
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function(ev){ document.addEventListener(ev, restart); });
})();
